import { createFileRoute } from "@tanstack/react-router";
import { JaziaShell } from "@/components/jazia/JaziaApp";
import { CreatePurchasePage } from "@/components/purchases/CreatePurchasePage";
import { requireAuth } from "@/lib/require-auth";

export const Route = createFileRoute("/purchases_/new")({
  beforeLoad: () => {
    requireAuth();
  },
  component: () => (
    <JaziaShell page="purchases">
      <CreatePurchasePage />
    </JaziaShell>
  ),
});
